/**
 * Sidebar entries for editing the website: the team, the projects and the
 * services the public pages read. Admins only; the API enforces the same.
 */
import { Briefcase, Layers, Users } from 'lucide-react';
import type { NavItem } from './nav.base';

export const items: NavItem[] = [
  { to: '/dashboard/team', label: 'Team', icon: Users, role: 'admin', section: 'Website', order: 30 },
  { to: '/dashboard/projects', label: 'Projects', icon: Briefcase, role: 'admin', order: 40 },
  { to: '/dashboard/services', label: 'Services', icon: Layers, role: 'admin', order: 50 },
];
